import styled from 'styled-components';

export const Flex1 = styled.div`
  flex: 1;
`;

export const TransferMilage = styled(Flex1)`
  display: flex;
  flex-direction: column;
`;

export const TransferMilageBox = styled(Flex1)`
  display: flex;
  align-items: flex-start !important;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: column;
    align-items: unset !important;
  }
`;
export const TransferMilageBoxLeft = styled(Flex1)`
  margin-inline-end: ${({ theme }) => theme.spacing.x4};
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    margin-bottom: ${({ theme }) => theme.spacing.x8};
    margin-inline-end: 0;
  }
`;
export const TransferMilageBoxLeftCard = styled(Flex1)`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x5}`};
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;

export const TransferMilageBoxLeftMember = styled.div`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x4} ${theme.spacing.x6}`};
  display: flex;
  flex-direction: column;
`;

export const TransferMilageBoxLeftText = styled.p`
  font-weight: 500;
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;

export const TransferMilageBoxLeftMemberDivider = styled.div`
  margin: ${({ theme }) => theme.spacing.x8} 0;
  display: flex;
  border: 1px solid #d8dbdf;
  position: relative;
`;

export const TransferMilageBoxLeftMemberDividerSpan = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #d8dbdf;
  background: ${({ theme }) => theme.palette.white};
  padding: ${({ theme }) => theme.spacing.x1};
`;

export const TransferMilageBoxLeftBtn = styled(Flex1)`
  margin: auto auto 0;

  font-size: ${({ theme }) => theme.fs.xs};
`;

export const TransferMilageBoxRight = styled(Flex1)`
  max-width: 400px;
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    max-width: 100%;
  }
`;
